import MovieItem from './MovieItem';
import FeaturedItem from './FeaturedItem';

export default MovieItem;
export { FeaturedItem };